import { Cell } from '@pelckmans/elementis/components/table';
import DetailsIcon from '@pelckmans/elementis/icons/details';
import RetryIcon from '@pelckmans/elementis/icons/retry';
import { useContext, useId } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../../../../contexts/ModalContext';
import { ScorableItem } from '../../../api/scorable-items';
import { useFilters } from '../../../context/filter-context/FilterContext';
import HistoryModal from '../../history-modal/HistoryModal';

export default function ActionCell({
  scorableItem,
  memberId,
  groupId,
  isAssignment,
}: {
  scorableItem: ScorableItem;
  memberId: string;
  groupId: string;
  isAssignment: boolean;
}) {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const modalId = useId();
  const { selectedModule } = useFilters();

  function handleOpenSessionsModal() {
    showModal(
      <HistoryModal
        id={modalId}
        scorableItem={scorableItem}
        memberId={memberId}
        groupId={groupId}
        moduleId={selectedModule!.id}
        isAssignment={isAssignment}
      />,
    );
  }

  return (
    <Cell
      buttonGroupProps={{
        'aria-label': t('PAGES.RESULTS.PER_STUDENT.TABLE.SCORABLE_ITEM.SINGLE_STUDENT.ACTIONS.GROUP_A11Y_LABEL'),
        role: 'group',
      }}
    >
      <Cell.Button
        startIcon={<RetryIcon data-testid="share-icon" />}
        disabled
        prominence="neutral"
        aria-label={t('PAGES.RESULTS.PER_STUDENT.TABLE.SCORABLE_ITEM.SINGLE_STUDENT.ACTIONS.SHARE_BUTTON_A11Y_LABEL')}
      />
      <Cell.Button
        startIcon={<DetailsIcon data-testid="open-sessions-modal" />}
        onClick={handleOpenSessionsModal}
        prominence="neutral"
        aria-label={t(
          'PAGES.RESULTS.PER_STUDENT.TABLE.SCORABLE_ITEM.SINGLE_STUDENT.ACTIONS.SESSION_MODAL_BUTTON_A11Y_LABEL',
        )}
      />
    </Cell>
  );
}
